// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"U3-z"};